import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
// import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
import usePageTitle from "app/pageTitle";

function LeadBucketsPage() {
  const pageTitle = "Lead Buckets";
  usePageTitle(pageTitle);

  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [buckets, setBuckets] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("agents/leads/buckets.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setBuckets(result.data.data.buckets);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox mt={1} mb={5}>
        <MDBox p={1} display="flex" justifyContent="space-between">
          <MDTypography variant="h6">Lead Buckets</MDTypography>
          <MDBox>
            <MDTypography fontSize={24}>
              <Icon>people</Icon>
            </MDTypography>
          </MDBox>
        </MDBox>
        <MDBox mt={3}>
          {buckets.map((bucket) => (
            <MDBox mb={3.6}>
              <Card>
                <MDBox p={2}>
                  <MDBox display="flex" justifyContent="space-between">
                    <MDBox>
                      <MDTypography variant="h6" fontSize={16}>
                        {bucket.title}
                      </MDTypography>
                      <MDTypography
                        variant="h6"
                        fontSize={12}
                        fontWeight="regular"
                      >
                        {bucket.lead_type}
                      </MDTypography>
                    </MDBox>
                    <MDBox>
                      <MDTypography fontSize={24}>
                        <Icon color="dark">chevron_right</Icon>
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          ))}
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default LeadBucketsPage;
